'use client'

import { PropsWithChildren } from 'react';

interface CardBoxCheckoutProps {
    icon?: any;
    iconTop?: boolean;
    className?: string;
    loading?:boolean;
    loadingOneRow?:boolean;
    loadingButton?:boolean;
    loadingFull?:boolean;
}

const CardBoxCheckout = ({icon, iconTop=true, className, loading, loadingOneRow=false, loadingButton=false, loadingFull=false, children}: PropsWithChildren<CardBoxCheckoutProps>) => {
    return (
        loading ?
            <div className={`flex gap-2 w-full justify-between items-center rounded-md p-4 bg-gray-50 animate-pulse ${className}`}>
                { icon && <div className={`self-start bg-gray-200 max-w-5 max-h-5 min-w-5 min-h-5 rounded-full`}></div> }
                <div className='flex gap-1.5 w-full justify-between'>
                    <div className='grid gap-1.5 w-full'>
                        {!loadingOneRow && <div className="flex flex-col w-1/4 bg-gray-200 h-3 rounded-md"></div>}
                        <div className={`flex flex-col ${loadingFull ? 'w-full' : 'w-1/2'} bg-gray-200 h-3 rounded-md`}></div>
                    </div>
                    {loadingButton && <div className="flex flex-col w-1/4 bg-gray-200 h-3 rounded-md"></div>}
                </div>
            </div>
        :
            <div className={`flex gap-2 w-full justify-between items-center rounded-md p-2 bg-gradient-to-r from-gray-50 to-gray-50/75 ring-1 ring-gray-100 shadow shadow-gray-100 ${className}`}>
                { icon && <div className={`text-lg ${iconTop && 'self-start'}`}>{ icon }</div> }
                <div className="flex flex-col w-full">
                    { children }
                </div>
            </div>
    )
}

export default CardBoxCheckout;